import { UploadOutlined } from "@ant-design/icons";
import { Card } from "@comps";
import { Http } from "@utils";
import { Button, Col, Form, Row, Space, Upload, message } from "antd";
import React, { FC, useState } from "react";
interface Props {
  /**
   * 文件选择类型
   */
  accept?: string;
  /**
   * 文件上传地址
   */
  url: string;
  /**
   * 模板下载地址
   */
  templateUrl?: string;
  downloadUrl?: string;
  downloadName?: string;
  /**
   * 最大文件大小
   */
  maxSize?: number;
  /**
   * 最大上传数量
   */
  maxCount?: number;
  /**
   * 上传文件类型
   */
  fileType?: string[];
  /**
   * 获取文件上传结果
   */
  getResult?: (data: JSONObject) => void;
  table: any;
  reject: Function;
}
const UploadModal: FC<Props> = ({
  accept = ".xls,.xlsx",
  fileType = [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
  ],
  templateUrl = "",
  downloadUrl = "",
  downloadName = "导入模板",
  url,
  maxSize = 50,
  maxCount = 1,
  reject,
  table,
  getResult,
}) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<any[]>([]);
  const [file, setFile] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = ({ file, fileList }: any) => {
    // 文件类型检查
    let checkedFileList: any[] = checkFileList(file, fileList);
    setFileList(checkedFileList);
  };

  const checkFileList = (currentFile: File, currentFileList: []) => {
    let newFileList: any[] = [];
    currentFileList.map((fileItem: File, index: number) => {
      const isTrueFormatter = fileType.includes(fileItem.type);
      const overFlowMaxSize = fileItem.size / 1024 / 1024 > maxSize;
      if (!isTrueFormatter) {
        message.error("请上传正确类型");
        return;
      } else if (overFlowMaxSize) {
        message.error("文件大小不能超过50MB!");
        return;
      } else if (index + 1 > maxCount) {
        newFileList[newFileList.length - 1] = fileItem;
        message.warning("上传文件数量不可超过" + maxCount + "个");
        return;
      } else {
        newFileList.push(fileItem);
        setFile(fileItem);
      }
    });
    if (!newFileList.length) {
      setFile(null);
      form.resetFields();
    }
    return newFileList;
  };

  const handleUpload = () => {
    form.validateFields().then(() => {
      setLoading(true);
      let formData = new FormData();
      if (maxCount === 1 && file?.originFileObj) {
        //单文件
        formData.append("file", file?.originFileObj);
      } else if (maxCount > 1) {
        //多文件
        fileList.map((fileItem: JSONObject, index: number) => {
          formData.append(`file${index}`, fileItem?.originFileObj);
        });
      }
      Http.postWithFormData(url, formData)
        .then((res) => {
          reject();
          table?.refresh();
          if (getResult) {
            getResult(res);
          }
          message.success("操作成功");
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  const handleDownLoadTemp = () => {
    Http.getDownload(downloadName, downloadUrl);
  };
  return (
    <Card title="导入">
      <Form style={{ padding: "16px" }} layout="vertical" form={form}>
        <Row>
          <Col span={24}>
            <Form.Item
              name="file"
              label="请选择需要导入的文件"
              rules={[
                {
                  required: true,
                  message: "请选择需要导入的文件",
                },
              ]}
            >
              <Upload
                fileList={fileList}
                onChange={handleFileChange}
                beforeUpload={() => false}
                multiple={false}
                accept={accept}
              >
                <Button icon={<UploadOutlined />}>选择文件</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          {templateUrl !== "" && (
            <Col>
              <a href={templateUrl}>下载模板</a>
            </Col>
          )}
        </Row>
        <Row>
          {downloadUrl !== "" && (
            <Col>
              <a onClick={handleDownLoadTemp}>下载模板</a>
            </Col>
          )}
        </Row>
        <Row style={{ textAlign: "center", marginTop: "10px" }}>
          <Col span={24}>
            <Space>
              <Button
                type="primary"
                onClick={() => handleUpload()}
                loading={loading}
              >
                确定
              </Button>
              <Button onClick={() => reject()}>取消</Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};
export default UploadModal;
